(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lash-nail-explorer"] && !Shopify.designMode) return;
  try {
    
class NailExplorer extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.filters = Array.from(this.querySelectorAll('[data-nail-filter]'));
    if (this.filters.length !== 4) return;
    this.cards = Array.from(this.querySelectorAll('[data-nail-product]'));
    this.finishes = Array.from(this.querySelectorAll('[data-nail-finish]'));
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.filters.forEach((select) => {
      const values = new Set(Array.from(select.options, (option) => option.value));
      this.cards.forEach((card) => {
        const value = card.dataset[select.dataset.nailFilter]?.trim();
        if (value && !values.has(value)) {
          select.add(new Option(value, value));
          values.add(value);
        }
      });
    });
    this.addEventListener('change', (event) => {
      if (event.target.matches('[data-nail-filter]')) this.updateEdit();
    }, options);
    this.addEventListener('click', (event) => {
      const finish = event.target.closest('[data-nail-finish]');
      const clear = event.target.closest('[data-nail-clear]');
      if (finish && this.contains(finish)) {
        this.querySelector('[data-nail-filter="finish"]').value = finish.dataset.nailFinish;
        this.updateEdit();
        this.querySelector('.nail-results')?.scrollIntoView?.({ behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'instant' : 'smooth', block: 'start' });
      } else if (clear && this.contains(clear)) {
        this.filters.forEach((select) => { select.value = ''; });
        this.updateEdit();
      }
    }, options);
    this.updateEdit();
    this.dataset.nailEnhanced = 'true';
  }

  updateEdit() {
    const edit = Object.fromEntries(this.filters.map((select) => [select.dataset.nailFilter, select.value]));
    this.filters.forEach((select) => {
      this.querySelector('[data-nail-summary-value="' + select.dataset.nailFilter + '"]').textContent = select.value || 'Any';
    });
    this.finishes.forEach((button) => {
      const selected = button.dataset.nailFinish === edit.finish;
      button.setAttribute('aria-pressed', String(selected));
      button.querySelector('[data-nail-finish-label]').textContent = selected ? 'Selected for your edit' : 'Explore this finish';
    });
    this.querySelectorAll('[data-nail-clear]').forEach((button) => {
      button.disabled = !Object.values(edit).some(Boolean);
    });
    const facetActive = Object.values(edit).some(Boolean);
    let visible = 0;
    this.cards.forEach((card) => {
      const matches = Object.entries(edit).every(([key, value]) => !value || (card.dataset[key] || '').trim().toLowerCase() === value.toLowerCase());
      card.dataset.nailFacetMatch = String(matches);
      if (matches) visible += 1;
    });
    const previewCatalog = this.querySelector('[data-nail-preview-catalog]');
    if (previewCatalog) {
      previewCatalog.dataset.nailFacetActive = String(facetActive);
      previewCatalog.dispatchEvent(new CustomEvent('nail:facets-changed'));
    }
    const hasCatalog = this.cards.length > 0;
    const unbound = this.querySelector('[data-nail-unbound]');
    if (unbound) unbound.hidden = hasCatalog;
    const empty = this.querySelector('[data-nail-empty]');
    if (empty) empty.hidden = !hasCatalog || visible > 0;
    const count = this.querySelector('[data-nail-count]');
    if (count) count.textContent = visible + (visible === 1 ? ' matching style' : ' matching styles') + ' in this edit';
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('nail-explorer')) customElements.define('nail-explorer', NailExplorer);

  } catch(e) { console.error(e); }
})();
})();
